import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Welcome from "./Welcome";
import HostAccess from "./HostAccess";
import GuestLanding from "./GuestLanding";
import Room from "./Room";
import GuestRoom from "./GuestRoom";  // add this import at top

// New imports
import PlanSelection from "./components/PlanSelection";
import AdminDashboard from "./components/AdminDashboard";

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Welcome />} />
        <Route path="/plan" element={<PlanSelection />} />
        <Route path="/hostaccess" element={<HostAccess />} />
        <Route path="/room" element={<Room />} />
        <Route path="/guest" element={<GuestLanding />} />
        <Route path="/guestroom" element={<GuestRoom />} /> {/* adjust if you have GuestRoom */}
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </Router>
  );
}
